import { Controller } from 'stimulus'
import { setPickerValue } from '../lib/date_range_picker'

import 'bootstrap-daterangepicker/daterangepicker'
import moment from 'moment'

export default class extends Controller {
    static targets = ['picker']

    connect() {
        this.handle_filter_form()
    }

    handle_filter_form() {
        $(this.pickerTarget).daterangepicker({
            autoUpdateInput: false,

            locale: {
                format: 'DD/MM/YYYY'
            },

            ranges: {
                'Vandaag': [moment(), moment()],
                'Gisteren': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Afgelopen 30 dagen': [moment().subtract(29, 'days'), moment()],
                'Deze maand': [moment().startOf('month'), moment().endOf('month')],
                'Vorige maand': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Dit jaar': [moment().startOf('year'), moment().endOf('year')],
                'Vorig jaar': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
            }
        })

        $(this.pickerTarget).on('apply.daterangepicker', (event, picker) => {
            let changeEvent = new Event('change', { bubbles: true })
            let value = picker.startDate.format(picker.locale.format) + picker.locale.separator + picker.endDate.format(picker.locale.format)

            setPickerValue(picker)
            picker.element[0].dispatchEvent(changeEvent)
        })
    }
}
